import { postJson } from "@/ajax/http";
import { ContentManageApiUrl, SiteCode } from "@/config/sys.config";

export const cmApi = {
    getInheritValue: (data) => {
        const url = ContentManageApiUrl + '/config-item/value/getInheritValue'
        return postJson(url, data);
    },
    getPublicConfig: (pageId) => {
        return cmApi.getInheritValue({ pageId, moduleCode: 'ZNWD_PUBLIC', siteCode: SiteCode });
    }
}
